import { zones as zonesService } from 'services/zones';
import { ZoneInfo } from './zone-info';
import { Content, CheckBox, CheckboxWrapper, Discription, Name, RowContentWrapper, TextWrapper } from './rules-row.styled';

export const RulesRow = (props) => {
  const { disabled } = props;

  const getValue = (zone) => {
    let result = {
      nodes: {},
    };
    zone.nodes.forEach((node) => {
      let enabledRacks = [];
      let complete = true;

      node.racks.forEach((rack) => {
        const toolTip = zonesService.getRackTitle(zone.zone_id, node.node_id, rack.rack_id);

        if (rack.enabled) {
          enabledRacks.push('C' + toolTip);
        } else {
          complete = false;
        }
      });
      if (enabledRacks.length) {
        if (complete) {
          result.nodes[node.node_id] = true;
        } else {
          result.nodes[node.node_id] = enabledRacks;
        }
      }
    });

    if (Object.keys(result.nodes).length) {
      return <ZoneInfo nodes={result.nodes} disabled={disabled} />;
    }
  };

  const getCheckboxes = () => {
    const zonesArray = zonesService.getZones();
    const checkboxList = zonesArray.map((zone) => {
      const item = props.zones.find((el) => el.zone_id === zone.zone_id);
      const color = zone.background_color;
      return (
        <div onClick={() => props.action(item, props.rule_id)} key={item.zone_id}>
          <CheckboxWrapper color={color}>
            <CheckBox>{getValue(item)}</CheckBox>
          </CheckboxWrapper>
        </div>
      );
    });

    return checkboxList;
  };

  return (
    <Content disabled={disabled}>
      <TextWrapper>
        <Name>{props.name}</Name>
        <Discription>{props.discription}</Discription>
      </TextWrapper>
      <RowContentWrapper>{getCheckboxes()}</RowContentWrapper>
    </Content>
  );
};
